import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import BackToTop from "../components/BacktoTop";
import Catering from "../components/Catering";

const HomePage = () => {
  return (
    <>
      <Navbar></Navbar>
      <div role="main">
        <Catering/>
      </div>
      <Footer></Footer>
      <BackToTop></BackToTop>
    </>
  );
};

export default HomePage;
